var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSectionEnterprise2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1864_35188",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 0,
    width: 20,
    height: 42
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f833851b04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.5146 0H49.9741V41.4809H30.5146V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1864_35188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.9575 41.3232C47.7559 31.036 56.5284 0.00280762 39.9575 0.00280762C23.3865 0.00280762 32.4631 30.67 39.9575 41.3232Z",
    fill: "#D7D3F7"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1864_35188",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 38,
    width: 20,
    height: 42
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "5588e3c915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.5146 38.5979H49.9741V79.9999H30.5146V38.5979Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1864_35188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M39.9575 38.6825C47.7559 48.9697 56.5284 80.0029 39.9575 80.0029C23.3865 80.0029 32.4631 49.3356 39.9575 38.6825Z",
    fill: "#D7D3F7"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1864_35188",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 29,
    width: 42,
    height: 21
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "24f6470110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M0 29.9493H41.326V49.4088H0V29.9493Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1864_35188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M41.3223 40.0479C31.0352 32.2494 0.00195312 23.4769 0.00195312 40.0479C0.00195312 56.6188 30.6692 47.5422 41.3223 40.0479Z",
    fill: "#D7D3F7"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1864_35188",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 29,
    width: 42,
    height: 21
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "1fca7b02f8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M38.4434 29.9493H80.0002V49.4088H38.4434V29.9493Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1864_35188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M38.6826 40.048C48.9698 32.2496 80.003 23.477 80.003 40.048C80.003 56.6189 49.3358 47.5424 38.6826 40.048Z",
    fill: "#D7D3F7"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M72.1816 8.22639C72.8347 8.89362 70.0982 12.8294 64.5746 19.1723C59.051 25.5152 51.1934 33.7416 42.7277 42.044C34.2649 50.3491 25.8865 58.049 19.4423 63.4488C12.9952 68.8486 9.0059 71.5091 8.35275 70.8446C7.6996 70.1802 10.4361 66.2416 15.9597 59.9015C21.4834 53.5586 29.3409 45.3294 37.8066 37.0271C46.2694 28.7247 54.645 21.0248 61.0921 15.6222C67.5391 10.2224 71.5284 7.56198 72.1816 8.22639Z",
    fill: "#D7D3F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M8.95857 7.621C9.6258 6.97067 13.5616 9.70434 19.9045 15.228C26.2446 20.7516 34.4738 28.6092 42.7761 37.0748C51.0813 45.5377 58.7784 53.916 64.181 60.3631C69.5808 66.8074 72.2412 70.7967 71.5768 71.4498C70.9096 72.103 66.9738 69.3665 60.6309 63.8428C54.2908 58.3192 46.0616 50.4617 37.7592 41.9988C29.4541 33.5332 21.757 25.1576 16.3544 18.7105C10.9546 12.2635 8.29415 8.27416 8.95857 7.621Z",
    fill: "#D7D3F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSectionEnterprise2);
export default __webpack_public_path__ + "static/media/icon-section-enterprise-2.d6015a268468a99e834a238853ea55a5ed3ca7642fdf87212598338d6a2202a5.svg";
export { ForwardRef as ReactComponent };